import { useState } from 'react';

const useMaxHeightCard = () => {
  const [value, setValue] = useState(0);
  const set = (clientHeight, force = false) => {
    if (force || (clientHeight && clientHeight > value)) setValue(clientHeight);
  };
  const reset = () => {
    setValue(0);
  };

  return { value, set, reset };
};

export default useMaxHeightCard;
